import { loadingAsyncState } from 'widgets-for-react'

export async function submitContactForm(
  email: string,
  name: string,
  surname: string,
  subject: string,
  message: string
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(
    `/api/v1/contact-us?email=${email}&name=${name}&surname=${surname}&subject=${subject}&message=${message}`,
    {
      method: 'post',
      credentials: 'include',
      headers: headers,
    }
  )
  if (!res.ok) throw Error(res.statusText)
  return
}

export const loadSubmitContactForm = (
  email: string,
  name: string,
  surname: string,
  subject: string,
  message: string
) =>
  loadingAsyncState<{}>(() =>
    submitContactForm(email, name, surname, subject, message).then(() => ({
      kind: 'result',
      value: {},
      status: 200,
    }))
  )
